import React, { useState } from 'react';

import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';

import TabPageContainer from '~components/atoms/TabPageContainer';
import TabPageHeaderWrapper from '~components/atoms/TabPageHeaderWrapper';
import Text from '~components/atoms/Text';
import ActionButton from '~components/atoms/ActionButton';

import RolesTable from './RolesTable';
import RolesPaginator from './RolesPaginator';
import RolesCreateNewRoleModal from './RolesCreateNewRoleModal';
import RolesRoleDetailsModal from './RolesRoleDetailsModal';
import RolesDeleteRoleModal from './RolesDeleteRoleModal';

import { ModuleEnum, PermissionsEnum, RoleStatusEnum } from '~utils/enums';

import * as Styles from './_roles.module.scss';
import DownloadCSV from '~components/molecules/DownloadCSV';
import UtilFunctions from '~utils/functions';
import dayjs from 'dayjs';

const Roles = () => {
    const dispatch = useAppDispatch();

    const { Misc: { dateTimeFormat } } = UtilFunctions;

    const handleCreateNewRoleClick = () => dispatch(combinedActions.adminSetCreateNewRoleModalIsOpen(true));
    const exportAdminRoleListing = () => dispatch(combinedActions.adminExportAdminRoleListingAttempt());
    const clearAdminRoleListingForExport = () => dispatch(combinedActions.adminClearAdminRoleListingForExport());

    const [isExportingAdminUserListing, setIsExportingAdminUserListing] = useState(false);

    const getAdminRoleListingForExportIsLoading = useAppSelector(state => state.admin.loadings.exportAdminRoleListing);
    const createAccessModules = useAppSelector(state => state.auth.userDetails.access)?.find(access => access.permission === PermissionsEnum.Create)?.modules || [];
    const adminRoleListingForExport = useAppSelector(state => state.admin.adminRoleListingForExport);

    const handleExportInventoryTransactionListingCleanup = () => {
        clearAdminRoleListingForExport();
        setIsExportingAdminUserListing(false);
    };

    const listHeader = [
        'ROLE ID',
        'ROLE NAME',
        'ALL BRANCH ACCESS',
        'STATUS',
        'CREATED AT',
        'UPDATED AT',
    ];

    const listData = adminRoleListingForExport.map(role => {
        const {
            roleId,
            roleName,
            allBranchAccess,
            status,
            createdAt,
            updatedAt,
        } = role;

        return {
            roleId: roleId || '-',
            roleName: roleName || '-',
            allBranchAccess: allBranchAccess,
            status: RoleStatusEnum[status] || '-',
            createdAt: dateTimeFormat(createdAt) || '-',
            updatedAt: dateTimeFormat(updatedAt) || '-',
        };
    });

    return (
        <TabPageContainer>
            <TabPageHeaderWrapper>
                <Text
                    label='Roles List'
                    className={Styles.title}
                    size='l'
                    isBold
                />

                <div className={Styles['btn-container']}>
                    {createAccessModules.find(module => module === ModuleEnum.RBAC)
                        && (
                            <DownloadCSV
                                buttonLabel='Export Roles List to CSV'
                                header={listHeader}
                                data={listData}
                                fileName={dayjs().format('DD-MM-YYYY').concat(' Admin Role Listing')}
                                onClick={exportAdminRoleListing}
                                cleanup={handleExportInventoryTransactionListingCleanup}
                                isLoading={getAdminRoleListingForExportIsLoading || isExportingAdminUserListing}
                            />
                        )
                    }

                    {createAccessModules.find(module => module === ModuleEnum.RBAC)
                        && (
                            <ActionButton
                                label='+ Create New Role'
                                onClick={handleCreateNewRoleClick}
                            />
                        )
                    }
                </div>

            </TabPageHeaderWrapper>

            <RolesTable />

            <RolesPaginator />

            <>
                <RolesCreateNewRoleModal />

                <RolesRoleDetailsModal />

                <RolesDeleteRoleModal />
            </>
        </TabPageContainer>
    );
};

export default Roles;
